<template>
  <div>
    <b-row>
      <b-col cols="6">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i>
            Settings
          </div>
          <div class="card-body">
            <b-form @submit="onSubmit">
              <b-form-group id="input-group-1" label="Key:" label-for="input-1">
                <b-form-input id="input-1" v-model="form.key" :readonly="settingId != null"
                              placeholder="Enter Key"></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-2" label="Value:" label-for="input-2">
                <b-form-input id="input-2" v-model="form.value" placeholder="Enter Value"></b-form-input>
              </b-form-group>
              <b-form-group id="input-group-3" label="Description:" label-for="input-3">
                <b-form-input id="input-3" v-model="form.description" placeholder="Enter Description"></b-form-input>
              </b-form-group>
              <b-form-checkbox
                id="checkbox-1"
                v-model="form.isEncrypted"
                name="checkbox-1"
                value="true"
                unchecked-value="false"
              >Encrypt the value?
              </b-form-checkbox>
              <br>
              <b-form-checkbox
                id="checkbox-2"
                v-model="form.active"
                name="checkbox-2"
                value="true"
                unchecked-value="false"
              >Active?
              </b-form-checkbox>
              <br>
              <b-button type="submit" variant="primary" style="margin: 5px;">Save</b-button>
              <b-button style="margin: 5px;" @click="cancel">Cancel</b-button>
            </b-form>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';
    import settingService from '../../service';

    export default {
        data() {
            return {
                loader: null
                //   form: {
                //     id: 0,
                //     key: '',
                //     value: '',
                //     description: '',
                //     isEncrypted: '',
                //     active: ''
                //   }
            };
        },
        computed: {
            ...mapGetters('settings', ['setting']),
            form() {
                return this.setting;
            },
            //...mapState({ form: state => state.settings.setting }),
            settingId() {
                return this.$route.params.id;
            }
        },
        methods: {
            //...mapActions('settings', ['getById', 'update', 'create', 'manage']),
            ...mapActions('settings', ['getById', 'manage']),
            ...mapMutations('settings', ['setItem']),
            onSubmit: function (evt) {
                evt.preventDefault();
                this.loader = this.$loading.show();
                let data = {
                    id: this.form.id || 0,
                    key: this.form.key,
                    value: this.form.value,
                    description: this.form.description,
                    isEncrypted: this.form.isEncrypted,
                    active: this.form.active
                };

                if (this.settingId) {
                    // create setting
                    data = {id: this.settingId, setting: data}
                }
                this.manage(data)
                    .then(() => {
                        this.loader.hide();
                        //this.$snotify.success('Setting created', 'Setting');
                        this.$router.push('/settings');
                    })
                    .catch(() => {
                        this.loader.hide();
                        //this.$snotify.warning('Error creating setting', 'Setting');
                    });
            },
            cancel: function () {
                this.$router.push({name: 'SettingList'});
            }
        },
        created() {
            if (this.settingId) {
                this.setContainerLoader(true);
                this.getById(this.settingId).then(async () => {
                    this.setContainerLoader(false);
                }).catch(() => {
                    this.setContainerLoader(false);
                    //return back to listing page because error in fetch record
                    this.$router.push({name: 'SettingList'});
                });
            } else {
                this.setItem({resource: 'setting', payload: {}})
            }
        }
    };
</script>

